import { configureStore } from '@reduxjs/toolkit';
import persistedReducer from 'redux/reducers';
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
